module.exports = __webpack_public_path__ + "intuit.1X9U_6xH.svg";